import { includes, startCase, map, size, first, find } from "lodash";
import store from "@/store";
import { errorHandler } from "@/services/utils";
import { USER_STATUSES, USER_LIST_FILTERS } from "@/constants/users";
import { getListedArray } from "@/utils/helpers";

const showEmptyFullName = user => {
  return !user || !(user.firstName || user.lastName);
};

export const getFullName = user => {
  if (showEmptyFullName(user)) {
    return "";
  }
  let name = `${user.firstName} ${user.lastName}`;
  return name.trim();
};

export const withFullName = user => {
  if (!user) {
    return {};
  }
  return {
    ...user,
    fullName: showEmptyFullName(user)
      ? ""
      : `${user.firstName} ${user.lastName}`
  };
};

export const getRolesToDisplay = ({ roles }) => {
  return getListedArray(map(roles, role => getRoleToDisplay(role)));
};

export const getRoleToDisplay = role => {
  switch (role) {
    case "worker":
      return "Candidate";
    case "client overseer":
      return "Overseer";
    case "client hiring manager":
      return "Hiring Manager";
    case "client interviewer":
      return "Interviewer";
    case "msp admin":
      return "Super Admin";
    case "msp user":
      return "Admin";
    case "booking approver":
      return "Role Approver";
    default:
      return startCase(role);
  }
};

export const getLastBookingName = booking => {
  return booking ? booking.name : "No Live Bookings";
};

export const emailExistingError = email => {
  const errors = [
    {
      title: "Duplicate Email!",
      detail: `${email} already exist.`,
      status: 409
    }
  ];
  errorHandler(store.dispatch, { errors }, 15000);
};

export const isWorker = roles => {
  return includes(roles, "worker");
};

export const getRoles = roles => {
  roles = map(roles, role => startCase(role));
  const rolesData = roles.join(", ");
  return rolesData;
};

export const getColorByStatus = status => {
  const { INCOMPLETE, INACTIVE, ACTIVE, INVITED } = USER_STATUSES;

  switch (status.toLowerCase()) {
    case ACTIVE:
      return "green";
    case INVITED:
      return "yellow";
    case INACTIVE:
      return "red";
    case INCOMPLETE:
      return "blue";
    default:
      return "gray";
  }
};

export const formatAddress = (addresses, countries) => {
  if (size(addresses)) {
    const { line1, line2, line3, postCode, country } = first(addresses);
    const userCountry = find(
      countries,
      storedCountry => storedCountry.id == country
    );
    return [
      line1,
      line2,
      line3,
      postCode && postCode,
      userCountry && userCountry.countryName
    ]
      .filter(Boolean)
      .join(", ");
  }
  return null;
};

export const getUserListFilters = allFilters => {
  return Object.keys(allFilters)
    .filter(key => includes(Object.keys(USER_LIST_FILTERS), key))
    .reduce((obj, key) => {
      obj[key] = allFilters[key];
      return obj;
    }, {});
};

export const showCandidateName = application => {
  const { user } = application;
  return user && Boolean(user.firstName) && Boolean(user.lastName);
};

export const getCandidateName = ({ user, id }) => {
  return showCandidateName({ user }) ? getFullName(user) : `Candidate ${id}`;
};
